import React from "react";
import PageLayout from "../PageLayout";
import Conversor from "../Conversor";
import "./Home.css";

const Home = () => {
  return (
    <PageLayout>
      <main className="home-main">
        <Conversor />
      </main>
    </PageLayout>
  );
};

export default Home;
